export const documentTypeInservice = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },
];
export const documentTypeHardship = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },

  {
    description: "Hardship documentation",
    isRequired: false,
    isAdded: false,
    isViewOnly: true,
  },
];
export const documentTypeSFS = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },
];
export const documentTypeForceout = [];

export const documentTypePermissible = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },
];
export const documentTypeRMD = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },
];
export const documentTypeQBAD = [
  {
    description: "Spousal consent",
    isRequired: false,

    isAdded: false,

    isViewOnly: true,
  },

  {
    description: "Birth Certificate or adoption Document",
    isRequired: true,
    isAdded: false,
    isViewOnly: true,
  },
];
